export default class Header {
    constructor() {
        this.headerHeightOffset = 50;
        this.header = document.querySelector('header');
        this.scrollTop = (document.documentElement || document.body).scrollTop;
        this.lastScrollTop = 0;
        if (!this.header)
            return;
        this.headerHeight = this.header.offsetHeight + this.headerHeightOffset;
        this.triggerHeader();
        this.addEventListeners();
    }
    addEventListeners() {
        window.addEventListener('resize', () => {
            this.headerHeight = this.header.offsetHeight;
        });
        window.addEventListener('scroll', () => {
            this.scrollTop = (document.documentElement || document.body).scrollTop;
            this.triggerHeader();
            this.lastScrollTop = this.scrollTop;
        });
    }
    triggerHeader() {
        // remove all classes when at top or within header height
        if (this.scrollTop <= this.headerHeight) {
            this.header.classList.remove('header-scrolled', 'header-hidden');
            return;
        }
        // always add 'header-scrolled' if scrolled past header height
        if (this.scrollTop > this.headerHeight) {
            this.header.classList.add('header-scrolled');
        }
        // hide header if scrolled further than header height
        if (this.scrollTop > this.lastScrollTop && this.scrollTop > this.headerHeight) {
            this.header.classList.add('header-hidden');
        }
        else {
            this.header.classList.remove('header-hidden');
        }
    }
}
